import { Component, OnInit } from '@angular/core';
import { MrService } from '../mr.service';
import { PatientService } from 'src/app/shared/patient-service/patient.service';

@Component({
  selector: 'app-medical-r',
  templateUrl: './medical-r.component.html',
  styleUrls: ['./medical-r.component.css']
})
export class MedicalRComponent implements OnInit {
  doctorId: any;
  clinicId: any;
  date4: Date = new Date();
  data: any
  parsedData: any;
  cities: any;
  iscity = true;
  isline = true;
  City: any='';
  selectedHospital:any;
  city: any;
  page:number = 1;
  limit:number = 5;
  docdata:any;
  hospital: any;
  hos: any;
  hospitalOption:any;
  hosId:any;
  mrid: any;
  curHospital:any;
  

  constructor(private mrservice: MrService, private patservice: PatientService) {
  }

  ngOnInit(): void {
    
  }

  bookAppt(doc:any) {
    const storedData = localStorage.getItem('myData');
    if (storedData) {
      this.parsedData = JSON.parse(storedData);
      this.mrid = this.parsedData.userData?._id
    } else {
      console.log('No data found in localStorage.');
    }
    this.doctorId = doc._id
    this.clinicId = doc.clinicId[0]
    console.log('this is clinicid',this.clinicId)
    // console.log(this.doctorId)
    let payload = {
      doctorId: this.doctorId,
      clinicId: this.clinicId,
      appointmentDate: this.date4,
      mrId: this.mrid
    }
    console.log(payload);
    this.mrservice.bookAppt(payload).subscribe((res: any) => {
      console.log("booking successfully", res)
      this.data = res;
    });
  }  

  findCity(data) {
    console.log("this CITY", data);
    this.patservice.getcity(data.target.value).subscribe((res: any) => {
      console.log("this is city", res);
      this.cities = res.res;
      this.isline = false;
    });
  }

  selectcity(city){
    console.log(city);
    this.city = city.terms[0].value;
    console.log(this.city);
    this.gethosbycity();
  }

  gethosbycity(){
    this.mrservice.getHos(this.page,this.limit,this.city).subscribe((res:any)=>{
      console.log("cities by hospitals", res);
      this.hospital = res.data.docs;
      this.iscity = false;
      this.getdocbyhos();
      this.gethosdoc(event);
    })
  }

  getdocbyhos(){
    this.hos = this.hospital;
    this.hosId = this.hos._id;
  }

  gethosdoc(event:any){
    console.log(event.target.value);
    let id = event.target.value;
    this.curHospital = this.hos.filter(h=>h._id == id)[0];
    this.mrservice.getHosdoc(this.page,this.limit,id).subscribe((res:any)=>{
      this.docdata = res.data.docs;
      console.log("this is response",this.docdata);
    });
  }

  onlogout(){
    this.mrservice.onLogout();
  }
}